<template>
  <div class='table-container'>
    <v-data-table :headers="headers" :items="data" class="elevation-1"></v-data-table>
  </div>
</template>

<script>
export default {
  props: {
    headers: {
      type: Array,
      default() { return [{ text: 'headerOne', value: 'headerOne' }, { text: 'headerTwo', value: 'headerTwo' }, { text: 'headerThree', value: 'headerThree' }] },
    },
    data: {
      type: Array,
      default() { return [{ headerOne: 20, headerTwo: 10, headerThree: 12 }] },
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.table-container {
  padding: 15px;
}
</style>
